<template>
    <div>
        <section>
            <div class="container">
                <ol class="breadcrumb hidden-xs">
                    <li><a href="/">首頁</a></li>
                    <li><a href="#">加入聯盟</a></li>
                    <li class="active">填寫表單</li>
                </ol>
                <div class="row">
                    <div class="col-sm-offset-1 col-sm-10 col-xs-12">
                        <h4 class="title">立即填寫表單，成為聯盟商城的一份子</h4>
                        <p class="editor">
                            現在愛幫您平台讓您能夠與我們一同合作擴大消費市場，加入之後您可以體驗我們的網站及 APP 的服務支援，
                            並將商品推廣給我們的平台會員，讓您的商品快速擴展於平台。<br/><br/>
                            <br/><br/>
                            接下來需要您先填寫貴公司相關的資料表格，系統將會為您建立一組登入帳號，方便您進入我們的管理平台，以及請閱讀相關合約「
                            <a class="more" href="/static/files/agreement.pdf" target="_blank">聯盟合約下載</a>」
                        </p>
                        <h4 class="title">登入表單</h4>
                        <div class="apply_form">
                            <form class="form-horizontal">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputCo" class="col-sm-4 control-label input_required">公司/店面名稱</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="com_name" placeholder="公司/店面名稱" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputCoPhone" class="col-sm-4 control-label">公司電話</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="com_phone" maxlength="10" placeholder="公司電話">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">

                                        <div class="form-group">
                                            <label for="address" class="col-sm-3 control-label">地址</label>
                                            <div class="col-sm-4">
                                                <select class="form-control" v-model="countyval">
                                                    <option v-for="option in county" v-bind:value="option.value">
                                                        {{option.text}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-sm-4">
                                                <select class="form-control" v-model="districtval">
                                                    <option v-for="option in district" v-bind:value="option.value">
                                                        {{option.text}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="address" class="col-sm-3 control-label"></label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="address" placeholder="公司/店面地址">
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="inputUrl" class="col-sm-3 control-label">網址</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="com_site" placeholder="官方網址">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr/>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputConName" class="col-sm-4 control-label input_required">聯絡人姓名</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="contact_name" placeholder="聯絡人姓名" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputConPhone" class="col-sm-4 control-label input_required">聯絡人手機</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="contact_phone" maxlength="10" placeholder="聯絡人手機" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputEmail" class="col-sm-4 control-label">聯絡人信箱(帳號)</label>
                                            <div class="col-sm-8">
                                                <input type="email" class="form-control" v-model="email" placeholder="聯絡人信箱" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputEmail" class="col-sm-4 control-label">密碼</label>
                                            <div class="col-sm-8">
                                                <input type="password" class="form-control" v-model="password" maxlength="20"  placeholder="請輸入您想要的密碼" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputConPhone" class="col-sm-3 control-label input_required">負責人會員編號</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="reliablemanid" placeholder="負責人會員編號" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputConPhone" class="col-sm-3 control-label input_required">商品類別</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="productCategory" placeholder="填寫商品類別" required>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="text-center">
                                      <input type="checkbox" v-model="i_read_agreement"/>
                                      「我已詳細閱讀 <a class="more" href="/static/files/agreement.pdf" target="_blank">聯盟合約</a> 內容」
                                    </div>
                                    <div class="text-center">
                                        <button type="button" class="btn btn-success" @click="apply()" :disabled="this.flag">確認申請</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'FreeTrial',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/api',
      com_name: '',
      com_phone: '',
      contact_name: '',
      email: '',
      password: '',
      county: this.$store.getters.getCounty,
      district: [],
      countyval: '',
      districtval: '',
      address: '',
      com_number: '',
      contact_phone: '',
      com_site: '',
      latest: '',
      productCategory: '',
      introduction: '',
      reliablemanid: 0,
      pricing: 10000,
      flag: false,
      i_read_agreement: false
    }
  },
  mounted: function () {
    this.$http.get(this.apiurl + '/latestAffiliate').then(function (res) {
      this.latest = res.body.data
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    apply () {
      let str = ''
      if (!this.i_read_agreement) {
        str += '請先勾選 「我已詳細閱讀聯盟合約內容」\n'
      } else if (!this.com_name) {
        str += '請填寫廠商名稱。\n'
      } else if (!this.com_phone) {
        str += '請先填寫聯絡電話。\n'
      } else if (this.contact_name === '') {
        str += '請先填寫聯絡人姓名。\n'
      } else if (this.email === '') {
        str += '請先填寫電子信箱。\n'
      } else if (this.password === '') {
        str += '請先填密碼。\n'
      } else if (this.pricing === '') {
        str += '請選擇上架費金額。\n'
      }

      if (this.countyval === '' || this.districtval === '') {
        str += '請選擇縣市及區域，(若持續出現，請換另一個瀏覽器嘗試)\n'
      }
      if (this.address === '') {
        str += '請填寫地址\n'
      }

      const rulename = new RegExp('^[\u4e00-\u9fa5_a-zA-Z]+$')
      if (!rulename.test(this.contact_name)) {
        str += '您的姓名只能輸入中文或英文。\n'
      }

      const rulphone = new RegExp('^[09]{2}[0-9]{8}$')
      if (!rulphone.test(this.contact_phone)) {
        str += '您輸入聯絡人手機不正確。\n'
      }
      const ruleEmail = new RegExp(/^[^\s]+@[^\s]+\.[^\s]+$/)
      if (!ruleEmail.test(this.email)) {
        str += '您輸入的Email不正確。'
      }
      if (str === '') {
        this.flag = true
        this.$http.post('https://affiliate.i80.com.tw/api/addAffiliate', {
          com_email: this.email,
          com_name: this.com_name,
          c_website: this.com_site,
          com_number: '',
          com_reliableman: this.contact_name,
          com_phone: this.com_phone,
          com_contact_phone: this.contact_phone,
          county: this.countyval,
          district: this.districtval,
          com_address: this.address,
          introduction: '',
          productCategory: this.productCategory,
          password: this.password,
          pricing: this.pricing,
          reliablemanid: this.reliablemanid
        }).then(function (res) {
          let status = res.body.status
          if (status === 200) {
            window.alert('申請成功，我們將盡快為您處理。')
          } else {
            window.alert('申請失敗，請重新申請。')
          }
        }, function () {
          console.log('failed')
        })
      } else {
        window.alert(str)
      }
    }
  },
  computed: {
    ...mapGetters([
      'getCounty'
    ])
  },
  watch: {
    countyval: {
      handler: function (val, oldVal) {
        let key = parseInt(val) - 1
        let district = this.$store.getters.getDistrict
        this.district = district[key]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FreeTrial.vue?3718f1e7